import React from 'react';
import AllRights from './AllRights';
import { Link } from 'react-router-dom';

function FooterSite(props) {


return (
  <>
<footer class="footer">
    <div class="container">
        <div class="footer-top">
            <div class="about_us">
                <h4 class="title">درباره بیت کالا</h4>
                <p class="body">هدف بیت کالا ارایه راهکار های نرم افزاری و مشاوره و خدمات نرم افزاری برای تولید پروژه های بزرگ و حساس می باشد که تیم بیت کالا متشکل از فرهیختگان و فارغ التحصیلانه رشته کامپیوتر و شبکه برای رسیدن به این مهم در همه مسیر همراه شما خواهند بود .</p>
            </div>
            <div class="roocket_section">
                <h4 class="title">بخش های سایت</h4>
                <ul class="body">
                    <li><Link to="/terms">قوانین و مقررات</Link></li>
                    <li><Link to="/ads">تبلیغات</Link></li>
                    <li><Link to="/about-us">درباره بیت کالا</Link></li>
                    <li><Link to="/contact-us">ارتباط با ما</Link></li>
                </ul>
            </div>
            <div class="contact_us">
                <h4 class="title">ارتباط با ما</h4>
                <div class="group">
                    <div class="body">
                        <p class="description">شما میتوانید با استفاده از یکی از راه&zwnj;های زیر با ما ارتباط برقرار کنید</p>
                        <ul>
                          
                            <li><i class="fa fa-phone"></i>  مشاوره :&zwnj;<span style={{fontWeight:"bold"}}>۰۹۱۲۴۵۴۱۲۳۱</span></li>
                            <li><i class="fa fa-phone"></i> شعبه مرکزی :&zwnj;<span style={{fontWeight:"bold"}}>۰۲۱-۸۸۸۰۲۵۹۴</span></li>
                            {/* <li><i class="fa fa-phone"></i> شعبه کرج :&zwnj;<span style={{fontWeight:"bold"}}>۰۲۶-۳۴۹۱۳۹۲۸</span></li> */}
                            <li><i class="fas fa-envelope"></i> ایمیل :&zwnj; <a href="mailto:info@bitkala.ir">info@bitkala.ir</a></li>

                            
                        </ul>
                    </div>
                    <p class="allow">
                        
                        
                    </p>
                </div>
            </div>
        </div>
    </div>
    
    <AllRights/>
 
</footer>
  </>
) 
}

export default FooterSite;